import {
  CredentialTableFields,
  IntegrationSetupStepInputType,
  IntegrationSetupStepType,
  ReportFields,
  SecretFieldType,
} from "../../../config/types";
import useAgentHandlerLinkModalContext from "../../context/useAgentHandlerLinkModalContext";
import ConnectorSetupStepBase from "./ConnectorSetupStepBase";
import useIntegrationSetupContext from "./useIntegrationSetupContext";

export type Inputs = Array<{
  placeholder: string;
  sublabel?: string | undefined;
  value: string | Blob | undefined;
  inputType?: IntegrationSetupStepInputType | undefined;
  acceptedFormats?: string | undefined;
  setValue: (value: string | any | undefined) => void;
  isRedacted?: boolean;
  prefix?: string;
  suffix?: string;
  options?: string[];
  error?: string;
  labelSubtitle?: string;
  fieldType?: SecretFieldType;
  selectOptions?: Array<{ label: string; value: string; default?: boolean }>;
  optional?: boolean;
}>;

interface Props {
  header?: string;
  subHeader?: string | React.ReactNode | null;
  description?: string;
  inputs?: Inputs;
  isStepComplete: boolean;
  allowContinueWithErrors?: boolean;
  setIsStepComplete?: (isStepComplete: boolean) => void;
  mergeToken?: string;
  ipAddresses?: string[];
  credentialTableFields?: CredentialTableFields;
  setCredentialTableFields?: (newCredentialTableFields: CredentialTableFields) => void;
  reportFields?: ReportFields;
  confirmMessage?: string;
  onSubmit?: (navigateToNextStep: () => void) => void;
  scrollHeight?: number;
  shouldShowHelpCenterButton?: boolean;
  errorMessage?: string;
}

const MainConnectorSetupStepBase = (props: Props) => {
  const { allowNavigateToPreviousEntryInHistory } = useAgentHandlerLinkModalContext();
  const {
    onExit,
    navigateToPreviousStep,
    navigateToNextStep,
    connector,
  } = useIntegrationSetupContext();

  const onNavigateToNextStep = () => {
    // Wait for onSubmit to return before navigating to next step
    if (props.onSubmit !== undefined) {
      props.onSubmit(navigateToNextStep);
    } else {
      navigateToNextStep();
    }
  };

  return (
    <ConnectorSetupStepBase
      currentStepType={IntegrationSetupStepType.STEP_TYPE_USERNAME_PASSWORD}
      description={""}
      connector={connector}
      onExit={onExit}
      navigateToPreviousStep={allowNavigateToPreviousEntryInHistory ? navigateToPreviousStep : undefined}
      navigateToNextStep={onNavigateToNextStep}
      {...props}
    />
  );
};

export default MainConnectorSetupStepBase;
